import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from 'src/styles/media';

import Container from 'components/Container';
import Info from './Info';

const Overlay = ({ onClickClose, isOpen, plan }) => {
  const handleClose = () => {
    onClickClose();
  };

  return (
    <Root isOpen={isOpen}>
      <Wrapper>
        {plan && (
          <ImageContainer>
            <Image
              src={`/assets/images/floorplans/${plan.id.toLowerCase()}.png`}
            />
            <Disclaimer>
              This is not an offering for sale as any such offering can only be
              made by way of Disclosure Statement. The developer reserves the
              right to make modifications and changes to floorplans, project
              design, materials and specifications without prior notice.
              Illustrations and renderings are for marketing purposes only and
              may differ from finished product. E.&O.E.
            </Disclaimer>
          </ImageContainer>
        )}
      </Wrapper>
      {plan && <Info plan={plan} />}
      <CloseBtn onClick={handleClose} />
    </Root>
  );
};

Overlay.propTypes = {
  onClickClose: PropTypes.func,
  isOpen: PropTypes.bool,
};

Overlay.defaultProps = {
  isOpen: false,
  onClickClose: f => f,
};

const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 9999;
  opacity: ${props => (props.isOpen ? '1' : '0')};
  pointer-events: ${props => (props.isOpen ? 'auto' : 'none')};
  transition: all 0.5s;
  overflow-y: scroll;
`;

const CloseBtn = styled.div`
  width: 47px;
  height: 47px;
  position: absolute;
  top: 35px;
  right: 35px;
  border-radius: 50%;
  background-color: rgba(9, 9, 9, 0.44);
  background-image: url(${require('src/assets/images/icons/close.svg')});
  background-repeat: no-repeat;
  background-position: 50% 50%;
  cursor: pointer;
  transition: background 0.33s;
  &:hover {
    background-color: rgba(9, 9, 9, 0.65);
  }
  @media (max-width: ${media.md}) {
    top: 15px;
    right: 15px;
  }
`;

const Image = styled.img`
  max-width: 80%;
  float: right;
  @media (max-width: ${media.md}) {
    margin-top: 40vh;
    max-width: 100%;
    /* float: none;
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translateX(50%) translateY(-50%);
    max-width: 100%;
    max-height: 100%; */
  }
`;

const Wrapper = styled(Container)`
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 350px;
  @media (max-width: ${media.md}) {
    margin-top: 0;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const Disclaimer = styled.p`
  text-align: center;
  font-size: 9px;
  width: 100%;
  left: 0;
  padding: 100px 20px 0;
  @media (max-width: ${media.md}) {
  }
`;

export default Overlay;



// WEBPACK FOOTER //
// ./src/pages/Plans/elements/Overlay.js